module.exports = __webpack_public_path__ + "img/q2_2020.bbd6d6f1.jpg";